// @ vendors
const Immutable = require('immutable');
// @ constants
const actionTypes = require('constants/actionTypes');

const initialState = Immutable.fromJS({
    'isFetching': false
});

const dataProprietorDelete = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.MORTGAGE_REQUEST_DELETE_DATA_PROPRIETOR_REQUEST:
            return state.merge({
                isFetching: true
            });
        case actionTypes.MORTGAGE_REQUEST_DELETE_DATA_PROPRIETOR_SUCCESS:
            return state.merge({
                isFetching: false
            });
        case actionTypes.MORTGAGE_REQUEST_DELETE_DATA_PROPRIETOR_FAILURE:
            return state.merge({
                error: action.data.error,
                isFetching: false
            });
        case actionTypes.MORTGAGE_REQUEST_UPDATE_DATA_PROPRIETOR_SUCCESS:
            return state.merge({
                idProprietor: action.data.idProprietor
            });
        default:
            return state
    }
};

module.exports = dataProprietorDelete;
